module.exports = __webpack_public_path__ + "static/media/adobe-brands.f1ba163a.svg";